import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { generateClient } from 'aws-amplify/api';
import { useBreadcrumbContext } from '../components/breadcrumb/BreadcrumbContext';

const client = generateClient();

const getCompanyName = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      name
    }
  }
`;

/**
 * Wrapper component that forces child routes to remount when companyId changes
 * This solves the issue where switching between companies doesn't reload the page
 */
export default function CompanyRouteWrapper() {
  const { companyid } = useParams();
  const { setDynamicLabel } = useBreadcrumbContext();

  useEffect(() => {
    if (!companyid) return;
    client.graphql({ query: getCompanyName, variables: { id: companyid } })
      .then(res => {
        const name = res.data?.getCompany?.name;
        if (name) setDynamicLabel(':companyid', name);
      })
      .catch(() => {});
  }, [companyid, setDynamicLabel]);

  // The key prop will change when companyid changes, forcing React to remount all child components
  return <Outlet key={companyid} />;
}
